import React, { useState, useEffect } from "react";
import styles from "./Karussell.module.css";

import carousel4 from "../../assets/images/Karussell/carousel4.avif";
import carousel5 from "../../assets/images/Karussell/carousel5.avif";
import carousel6 from "../../assets/images/Karussell/carousel6.avif";

const images = [carousel5, carousel4, carousel6];

function Karussell() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000); // wechsle alle 4 Sekunden
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles.sliderContainer}>
      {images.map((img, index) => (
        <img
          key={index}
          src={img}
          alt={`Slide ${index}`}
          className={`${styles.slide} ${
            index === currentIndex ? styles.active : ""
          }`}
        />
      ))}
    </div>
  );
}

export default Karussell;
